// extracted by mini-css-extract-plugin
export default {"SubText":"sumary-block_SubText__-SiFB","sumaryBlock":"sumary-block_sumaryBlock__wlyTD","sumaryTextBlock":"sumary-block_sumaryTextBlock__VxinB"};